// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"648565a0","160":"1019bdbe","322":"8a2955f5","695":"79e58244","904":"713d3089"}[chunkId] + ".chunk.css";
};